(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
const footerDisclosureMedia = window.matchMedia('(min-width: 700px)');
function syncFooterDisclosures(root = document) {
  root.querySelectorAll('.shopify-section--footer [data-footer-disclosure]').forEach((details) => {
    details.open = footerDisclosureMedia.matches;
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => syncFooterDisclosures(), { once: true });
} else {
  syncFooterDisclosures();
}
footerDisclosureMedia.addEventListener('change', () => syncFooterDisclosures());
document.addEventListener('shopify:section:load', (event) => syncFooterDisclosures(event.target));

  } catch(e) { console.error(e); }
})();
})();
